(() => {
  let queued = false;
  const update = () => {
    queued = false;
    const summary = document.querySelector('#rapi-cart-drawer-panel .rapi-cart-drawer__summary');
    if (!summary) return;
    const rows = [...summary.querySelectorAll('.rapi-cart-drawer__summary-row')];
    const discount = rows.find(row => row.querySelector('.rapi-cart-drawer__row-label')?.textContent.trim() === 'Réduction');
    const total = summary.querySelector('.rapi-cart-drawer__subtotal-value')?.closest('.rapi-cart-drawer__summary-row');
    if (!total) return;
    total.classList.add('mv-cart-total-row');
    if (discount) discount.classList.add('mv-cart-hidden-discount');
    let badge = total.querySelector('.mv-cart-total-savings');
    const amount = discount?.querySelector('.rapi-cart-drawer__row-value')?.textContent.trim().replace(/^[−–-]\s*/, '') || '';
    if (!amount || !/[1-9]/.test(amount)) { if (badge) badge.remove(); return; }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'mv-cart-total-savings';
      total.insertBefore(badge, total.querySelector('.rapi-cart-drawer__subtotal-value'));
    }
    const text = `Vous économisez ${amount}`;
    if (badge.textContent !== text) badge.textContent = text;
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  const start = () => {
    const connect = panel => { new MutationObserver(schedule).observe(panel, { childList: true, subtree: true, characterData: true }); schedule(); };
    const panel = document.querySelector('#rapi-cart-drawer-panel');
    if (panel) connect(panel);
    else {
      const waiting = new MutationObserver(() => {
        const next = document.querySelector('#rapi-cart-drawer-panel');
        if (next) { waiting.disconnect(); connect(next); }
      });
      waiting.observe(document.body, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

(()=>{const s=document.createElement("style");s.textContent="#rapi-cart-drawer-panel .rapi-cart-drawer__summary{padding-top:12px!important;padding-bottom:10px!important}#rapi-cart-drawer-panel .mv-cart-total-row{align-items:center!important;margin-top:0!important}";document.head.append(s)})();